import { render, staticRenderFns } from "./ArCollectionsParent.vue?vue&type=template&id=4a988441&"
import script from "./ArCollectionsParent.vue?vue&type=script&lang=js&"
export * from "./ArCollectionsParent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports